import React, { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';

export default ({
  children, options = [], onClick, onClose, position = { vertical: 'top', horizontal: 'right' },
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeHandler = () => {
    setAnchorEl(null);
    if (onClose) onClose();
  };

  const clickHandler = (link) => {
    onClick(link);
    closeHandler();
  };

  options = options.map((e) => (Array.isArray(e) ? e : [e, e]));

  return (
    <>
      <div className="inline-block" onClick={handleMenu}>
        {children}
      </div>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={position}
        keepMounted
        transformOrigin={position}
        open={Boolean(anchorEl)}
        onClose={closeHandler}
      >
        {options.map(([link, title]) => <MenuItem key={link} onClick={() => clickHandler(link)}>{title}</MenuItem>)}
      </Menu>
    </>
  );
};
